// api config!
const backendHost = process.env.REACT_APP_CONSUMER_URL;
const nodeBackendHost = process.env.REACT_APP_NODE_URL;

export const HOST_ROOT = `${backendHost}`;
export const API_ROOT = `${backendHost}/api`;

export const NODE_API_ROOT = `${nodeBackendHost}/api`;
export const ACCEPT_HEADER = { headers: {} };
export const defaultErrorMessage = "Oh no something went wrong.";